import { render } from "./ReleaseVideo.vue?vue&type=template&id=3d5fb50a&scoped=true&ts=true"
import script from "./ReleaseVideo.vue?vue&type=script&lang=ts"
export * from "./ReleaseVideo.vue?vue&type=script&lang=ts"

import "./ReleaseVideo.vue?vue&type=style&index=0&id=3d5fb50a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5fb50a"]])

export default __exports__